import React from "react";
import Modal from "./Modal";
import { Button, DPImage } from "../styles/commonStyles";
import styled from "styled-components";

const ConfirmationModal = ({
  title,
  primaryBtnText,
  secondaryBtnText = "Cancel",
  onPrimaryBtnClick,
  onSecondaryBtnClick,
  removeSecondaryBtn = false,
  open,
  setOpen,
  image,
  message,
  subMessage,
}) => {
  return (
    <Modal open={open} setOpen={setOpen} title={title} removePadding>
      <ContentWrapper>
        <DPImage src={image} />
        <ModalMessage>{message}</ModalMessage>
        <ModalSubMessage>{subMessage}</ModalSubMessage>
      </ContentWrapper>

      <ModalButtonContainer>
        {!removeSecondaryBtn && (
          <Button variant="outlined" block onClick={onSecondaryBtnClick}>
            {secondaryBtnText}
          </Button>
        )}
        <Button block onClick={onPrimaryBtnClick}>
          {primaryBtnText}
        </Button>
      </ModalButtonContainer>
    </Modal>
  );
};

export default ConfirmationModal;

export const ModalMessage = styled.p`
  font-size: 18px !important;
  font-weight: 500;
  line-height: 24px;
  margin-top: 20px;
  text-align: center;
`;

export const ModalSubMessage = styled.p`
  font-size: 16px !important;
  font-weight: 400;
  line-height: 22px;
  margin-top: 8px;
  color: #5e5e5e;
  max-width: 387px;
  word-break: keep-all;
  text-align: center;
`;

export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  padding: 20px;
  border-top: 1px solid #e0e0e0;
`;

export const ContentWrapper = styled.div`
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
